<template>
    <div>
        <tailwind-table
            :header="header"
            :has_filter=hasFilter
        >
            <template #filter>
                <floor-select
                    class="px-2"
                    v-model="floor"
                    :filter="true"></floor-select>
                <zone-select
                    class="px-2"
                    v-model="zone"
                    :groups="filteredGroups"
                    :filter="true"></zone-select>
                <desk-status
                    v-model="deskStatus"
                    class="px-2"
                ></desk-status>
            </template>
            <desk-table-item
                v-for="(desk, index) in filteredDesks"
                :item="desk"
                :group="group"
                :key="desk.id"
                @remove="load"
                @updated="load"
                :class="{'bg-gray-50': index % 2}"
            ></desk-table-item>
        </tailwind-table>
        <p class="mt-5 ml-auto mr-auto text-center" v-show="filteredDesks.length === 0"><strong>Keine Schreibtische gefunden.</strong></p>
    </div>
</template>

<script>
import TailwindTable from "./UI/TailwindTable";
import FloorSelect from "./FloorSelect";
import ZoneSelect from "./ZoneSelect";
import DeskTableItem from "./DeskTableItem.vue";
import DeskStatus from "./DeskStatus.vue";

export default {
    name: "DeskGroups",
    components: {
        DeskStatus,
        DeskTableItem,
        ZoneSelect,
        FloorSelect,
        TailwindTable
    },

    props: ['groups', 'desks', 'hasFilter'],

    data: () => ({
        floor: null,
        zone: null,
        deskStatus: null,
    }),

    inject: ['group'],

    computed: {
        filteredDesks() {
            return this.desks
                .filter(d => {
                    if (!this.floor) {
                        return true;
                    }

                    if (!d.floor) {
                        return false;
                    }

                    return d.floor.id === this.floor;
                })
                .filter(d => {
                    if (!this.deskStatus) {
                        return true;
                    }

                    return d.type === this.deskStatus;
                })
                .filter(d => {
                    if (!this.zone) {
                        return true;
                    }

                    if (!d.zones) {
                        return false;
                    }

                    return d.zones.map(g => g.id).includes(this.zone);
                });
        },
        filteredGroups() {
            return this.groups
                .filter(g => {
                    if (!this.floor) {
                        return true;
                    }

                    return g.floor_id === this.floor;
                })
                .sort((a, b) => a.name.localeCompare(b.name));
        },
        header() {
            if (!this.group.has_check_in) {
                return ['Status', 'Schreibtisch', 'Etage', 'Zonen', 'Besitzer', 'Austattung', ''];
            } else {
                return ['Status', 'Schreibtisch', 'Etage', 'Zonen', 'Besitzer', 'Austattung', 'QR-Code', ''];
            }
        }
    },

    methods: {
        load() {
            this.$emit('load');
        },
    }
}
</script>

